export default {"src":"https://s.sylndr.com/c-8dcefee/_next/static/media/NoHiddenCosts.f5ec8fc6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};